import React from "react";
import s1 from "../asset/review/s1.png";
import s2 from "../asset/review/s2.png";
import s3 from "../asset/review/s3.png";
import s4 from "../asset/review/s4.png";
import quote from '../asset/review/quote.png'

const reviews = [
  {
    name: "K W Vinod Kumar",
    title: "Senior Manager IT Operations",
    role: "Senior Manager IT Operations",
    review:
      "Grateful for an Exceptional Learning Experience! I would like to extend my heartfelt thanks to the entire Skillara team...",
    rating: 5,
    avatar: s1,
  },
  {
    name: "Devesh Bhatt",
    title: "Data Analyst",
    role: "Senior Manager IT Operations",
    review:
      "I took Power BI certification training and the experience I had was very good. The Instructor was knowledgeable and...",
    rating: 5,
    avatar: s2,
  },
  {
    name: "Harsha KR",
    title: "Senior Analyst",
    role: "Senior Manager IT Operations",
    review:
      "I recently completed the Data Science with Python course from Skillara, and I'm excited to share my positive experience...",
    rating: 5,
    avatar: s3,
  },
  {
    name: "K W Vinod Kumar",
    title: "Senior Manager IT Operations",
    role: "Senior Manager IT Operations",
    review:
      "Grateful for an Exceptional Learning Experience! I would like to extend my heartfelt thanks to the entire Skillara team...",
    rating: 5,
    avatar: s4,
  },
  {
    name: "Devesh Bhatt",
    title: "Data Analyst",
    role: "Senior Manager IT Operations",
    review:
      "I took Power BI certification training and the experience I had was very good. The Instructor was knowledgeable and...",
    rating: 5,
    avatar: s3,
  },
  {
    name: "M Srikanth",
    title: "Senior Analyst",
    role: "Senior Manager IT Operations",
    review:
      "I recently completed the Data Science with Python course from Skillara, and I'm excited to share my positive experience...",
    rating: 5,
    avatar: s1,
  },
];

const StarRating = ({ count }) => (
  <div className="flex items-center text-yellow-500 text-sm mt-4">
    {Array(count)
      .fill(0)
      .map((_, i) => (
        <span key={i}>★</span>
      ))}
    <span className="ml-2 text-gray-500 dark:text-gray-400">Excellent Experience</span>
  </div>
);

const StudentReviewCard = ({ name, title, role, review, rating, avatar }) => (
  <div className="relative w-full max-w-md">
    {/* Blue background border shadow */}
    <div className="absolute inset-0 bg-blue-900 dark:bg-blue-800 rounded-xl z-0 translate-x-2 translate-y-2 "></div>

    {/* Foreground Card */}
    <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 z-10">
      {/* Top Section */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex items-center">
          <img
            src={avatar}
            alt={name}
            className="w-10 h-10 rounded-full object-cover mr-3"
          />
          <div>
            <h3 className="text-base font-bold text-gray-800 dark:text-white">{name}</h3>
            <p className="text-sm text-blue-600 dark:text-blue-400 font-medium">{title}</p>
          </div>
        </div>

        {/* Quote icon */}
      <img src={quote} alt="quote"/>
      </div>

      {/* Role Badge */}
      <span className="inline-block bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300 text-xs font-medium px-3 py-1 rounded-md mb-4">
        {role}
      </span>

      {/* Review Text */}
      <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">“{review}”</p>

      {/* Star Rating */}
      <div className="flex items-center text-yellow-500 text-sm">
        {Array(rating)
          .fill(0)
          .map((_, i) => (
            <span key={i}>★</span>
          ))}
        <span className="ml-2 text-gray-500 dark:text-gray-400">Excellent Experience</span>
      </div>
    </div>
  </div>
);

const StudentReview = () => {
  return (
    <div className="bg-white dark:bg-gray-900 py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-blue-900 dark:text-white mb-2">
          Student Reviews
        </h2>
        <p className="text-center text-gray-600 dark:text-gray-300 mb-10">
          Here From our successful students who transformed their careers with
          SkillAra
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 place-items-center">
          {reviews.map((review, index) => (
            <StudentReviewCard key={index} {...review} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StudentReview;